<script setup lang="ts">
import { computed } from 'vue'
import {
  NXGDSToastNotificationGroup,
} from '@nsftx/seven-nxg-design-system'
import type { NXGDSToastClosePayload } from '@nsftx/seven-nxg-design-system'
import type { RetailNotification } from '#src/modules/notifications/interfaces/RetailNotification'
import type { RetailNotificationPosition } from '#src/plugins/types'
import { useNotificationsStore } from '#src/stores/notificationsStore'

const store = useNotificationsStore()

const props = withDefaults(
  defineProps<{
    position?: RetailNotificationPosition
    block?: boolean
  }>(),
  {
    position: 'topMiddle',
    block: false
  }
)

const notifications = computed({
  get: () => store.notifications,
  set: (nextNotifications) => store.syncNotifications(nextNotifications)
})

const toastPosition = computed(
  () => props.position
)

const onClose = ({ notification, reason }: NXGDSToastClosePayload) => {
  const retailNotification = notification as RetailNotification
  if (!retailNotification.id) return

  store.closeNotificationById(retailNotification.id, reason)
}
</script>

<template>
  <NXGDSToastNotificationGroup
    v-model="notifications"
    :position="toastPosition"
    :block
    @close="onClose"
  />
</template>
